import { USER_ROLE_MAP } from '@/const/user';
import { TransactionRoutes } from '../_OrgAdmin/routes/routes';
import { TransactionDetailsRoutes } from '../_OrgAdmin/pages/TransactionDetailsPage/routes/routes';
import { OutboundWireRoutes } from '../_OrgAdmin/pages/OutboundWire/routes/routes';
import { InboundWireRoutes } from '@/bundle/_OrgAdmin/pages/InboundWire/routes/routes';
import { DepositorRoutes } from '../_Depositor/routes/routes';
import { ExecutorRoutes } from '../_Executor/routes/routes';
import { RecipientWireRoutes } from '@/bundle/_Recipient/routes/routes';
import { MasterAdminRoutes } from '../_MasterAdmin/routes/routes';
import { OpcoUserRoutes } from '@/bundle/_Opco/_OpcoUsersPage/routes/routes';
import { OrganizationsRoutes } from '@/bundle/_Opco/routes/routes';
import { OrganizationRoutes } from '@/bundle/_Opco/ui/OrganizationDetails/routes/routes';
import { OpcoBillingRoutes } from '@/bundle/_Opco/_BilledEventsPage/routes/routes';
import { DepositAccountsRoutes } from '@/bundle/_OrgAdmin/pages/DepositAccountsPage/routes/routes';
import { MyVaultRoutes } from '@/bundle/_OrgAdmin/pages/MyVaultPage/routes/routes';
import { VendorVaultRoutes } from '@/bundle/_OrgAdmin/pages/VendorVaultPage/routes/routes';
import { AuditLogRoutes } from '@/bundle/_OrgAdmin/pages/AuditLogPage/routes/routes';
import { DashboardRoutes } from '@/bundle/_OrgAdmin/pages/DashboardPage/routes/routes';
import { InvoiceVaultRoutes } from '../_OrgAdmin/pages/InvoiceVaultPage/routes/routes';

export const SHARED_ORGANIZATION_ROUTES = [
  ...DashboardRoutes,
  ...MyVaultRoutes,
  ...VendorVaultRoutes,
  ...InvoiceVaultRoutes,
  ...AuditLogRoutes,
  ...TransactionRoutes,
  ...TransactionDetailsRoutes,
  ...DepositAccountsRoutes,
  ...OutboundWireRoutes,
  ...InboundWireRoutes,
];

export const PRIVATE_ROUTES = {
  [USER_ROLE_MAP.OPCO]: [...OrganizationsRoutes, ...OrganizationRoutes, ...OpcoUserRoutes, ...OpcoBillingRoutes],
  // Org Admin has only shared organization routes
  [USER_ROLE_MAP.MASTER_ADMIN]: [...MasterAdminRoutes],
  [USER_ROLE_MAP.DEPOSITOR]: [...DepositorRoutes],
  [USER_ROLE_MAP.EXECUTOR]: [...ExecutorRoutes],
  [USER_ROLE_MAP.RECIPIENT]: [...RecipientWireRoutes],
};
